export default __webpack_public_path__ + "static/How Can An Old Mattress Affect Your Sleep-6766352fdb61839c83a106897cb79c68.jpg";